// extracted by mini-css-extract-plugin
module.exports = {"operation_menu":"operation_menu--23L3x","hot":"hot--276lT","hotBox":"hotBox--3lFO6"};